export const useSingleButtonDialog = () => {
  const dialog = useState('single-button-dialog', () => ({
    visible: false,
    title: '',
    description: '',
    buttonText: '확인',
    customClass: 'single-button-warning-dialog',
    onConfirm: null as null | (() => void)
  }))

  const open = (options: {
    title: string
    description?: string
    buttonText?: string
    customClass?: string
    onConfirm?: () => void
  }) => {
    dialog.value = {
      visible: true,
      title: options.title,
      description: options.description ?? '',
      buttonText: options.buttonText ?? '확인',
      customClass: options.customClass ?? 'single-button-warning-dialog',
      onConfirm: options.onConfirm ?? null
    }
  }

  const close = () => {
    dialog.value.visible = false
    dialog.value.onConfirm = null
  }

  const confirm = () => {
    dialog.value.onConfirm?.()
    close()
  }

  return {
    dialog,
    open,
    close,
    confirm
  }
}
